import { DefaultValues } from "./default-values";

// This is the object that is passed to Tealium on the utag.view event, it should contain all the fields possible for all pages
export class PageViewData {
	/* ALL FIELDS NEED TO BE STRINGS OR STRING ARRAYS AND SET TO NULL IN ORDER FOR THE TRACKING TO WORK CORRECTLY */
	previous_page_path: string = null;
	page_id: string = null;
	page_name: string = null;
	// site_section: string = null;
	site_prod_domain: string = DefaultValues.site_prod_domain;
	event_trigger: string = null;
	tealium_event: string = null;
	reseller_id: string = null;

	products_availability_no: string[] = null;
	products_availability_yes: string[] = null;
	product_id: string[] = null;
	product_sku: string[] = null;
	product_brand: string[] = null;
	product_category: string[] = null;
	product_subcategory: string[] = null;
	product_name: string[] = null;
	product_variant: string[] = null;
	product_original_price: string[] = null;
	product_price: string[] = null;
	product_promo_code: string[] = null;
	product_quantity: string[] = null;
	product_concession: string[] = null;
	product_concession_memory: string[] = null;
	product_url: string[] = null;
	product_image_url: string[] = null;
	product_on_page: string[] = null;

	retail_vendor: string = null;
	retail_store_ID: string = null;
	sim_number: string = null;
	sim_value: string = null;

	billing_frequency: string = null;
	sales_id: string = null;
	cart_resume_url: string = null;
	cart_products_id: string[] = null;
	cart_products_sku: string[] = null;
	cart_products_brand: string[] = null;
	cart_products_category: string[] = null;
	cart_products_subcategory: string[] = null;
	cart_products_name: string[] = null;
	cart_products_variant: string[] = null;
	cart_products_original_price: string[] = null;
	cart_products_price: string[] = null;
	cart_products_promo_code: string[] = null;
	cart_products_quantity: string[] = null;
	cart_products_concession: string[] = null;
	cart_products_concession_memory: string[] = null;
	cart_products_discount: string[] = null;

	customer_address: string = null;
	customer_city: string = null;
	customer_state: string = null;
	customer_postcode: string = null;
	customer_country: string = null;
	customer_gnafid: string = null;
	customer_first_name: string = null;
	customer_last_name: string = null;
	customer_dob: string = null;
	customer_phone: string = null;
	customer_phone_local: string = null;
	customer_email: string = null;
	customer_street_address: string = null;
	customer_id: string = null;
	customer_ip_address: string = null;
	salesforce_lead_id: string = null;

	order_id: string = null;
	order_currency_code: string = null;
	order_original_total: string = null;
	order_discount_amount: string = null;
	order_shipping_amount: string = null;
	order_subtotal: string = null;
	order_tax_amount: string = null;
	order_total: string = null;
	order_payment_type: string = null;
	order_promo_code: string[] = null;
	order_shipping_type: string = null;
	order_store: string = null;

	error_code: string = null;
	error_description: string = null;

	// dealer portal
	dealer_name: string = null;
	checkbox_state: string = null;
	checkbox_state_value: string = null;
	cart_products_previous_subcategory: string[] = null;
	page_heading: string = null;
	dealer_reference_id: string = null;

	//mobile sim journey
	leadId: string = null;
	categoryName: string = null;
	product_sim_1P: string = null;
	product_sim_number: string = null;

}
